/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
import type { WidgetBookEventAddressPayload } from './WidgetBookEventAddressPayload';
export type WidgetBookEventPayload = {
    eventRuleId: number;
    eventCategoryId?: number;
    start: DateTime;
    end: DateTime;
    locationSelection?: WidgetBookEventPayload.locationSelection;
    paymentType?: WidgetBookEventPayload.paymentType;
    orderId?: string;
    useCredits?: boolean;
    address?: WidgetBookEventAddressPayload;
    fingerprint?: string;
};
export namespace WidgetBookEventPayload {
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
}

